import React, { Component} from 'react';
import {domainUrl, rootDomainUrl} from '../config/Config';
import * as Common from '../helpers/Common';
import {handleCheckbox, handleRadio, handleSequence} from '../helpers/Fields';
import Flowplayer from '../components/Flowplayer';
import TestGraph from '../components/TestGraph';

const $=window.$;

export default class Ctestresults extends Component {
	constructor(props) {
		super(props);
		this.state = {
			flowresult:false,
			componentStatus: this.props.data.status,
			observerEvaluation: false,
			evaluationPanel: false,
			testquestions: [],
			testcont: [],
			statusMessage: "",
			chart_graph:"",
			quscomd:[],
			actualToScore: "",
            percentage: "",
            winningAmount: "",
            losingAmount: "",
            performanceAmount: "",
            betStatus: "",
		};
	}
	getTestdetails(data){
		Common.reactLoader("show", "Please wait...");
		fetch(domainUrl+'normal-test/getresults', {
			method: 'POST',
		    headers: {
		      'Accept': 'application/json',
		      'Content-Type': 'application/json',
			  'Authorization':'Bearer ' +Common.getTokenData()
		    },
		    body: JSON.stringify({data})
		}).then((response) => response.json()).then((responseJson) => {

		    this.setState({
		    	testcont: responseJson.Mcq_details,
		    	testquestions: responseJson.McqQuestions,
		    	quscomd: responseJson.QuestionCom,
		    	chart_graph: (responseJson.Mcq_details.showgraph>0) ? <TestGraph scoredet={responseJson.Mcq_details}/> :'',
		    });

		    if(responseJson.Mcq_details.is_betcomponent>0){
			    this.setState({
			    	actualToScore: responseJson.bet_details.actualToScore,
	                percentage: responseJson.bet_details.percentage,
	                winningAmount: responseJson.bet_details.winningAmount,
	                losingAmount: responseJson.bet_details.losingAmount,
	                performanceAmount: responseJson.bet_details.performanceAmount,
	                betStatus: responseJson.bet_details.betStatus
			    });
		    }
			setTimeout(()=>{
				Common.contentResizeLoad();
				Common.showSmallLeftMenu();
				Common.contentResizeLoad();
				Common.reactLoader("hide");
		    }, 200);
		});
	}

	componentDidMount() {
		const {data}=this.props;
		if(data.flowresult){
			this.setState({ flowresult: true });
		}
		this.getTestdetails(data);
		setTimeout(()=>{
			$('audio').on("play", function (me) {
			  	$('audio').each(function (i,e) {
					if (e !== me.currentTarget) {
						this.pause();
					}
			  	});
			});
		},500)
	}
	componentWillReceiveProps(nextProps) {
		const {data}=nextProps;
		this.getTestdetails(data);
	}

	backToComponentList(){
		const {data}=this.props;
		this.props.switchback(data);
	}

	continueToComplete() {
		this.setState({ flowresult: false });
	}

  	getoptions(ans_opt){
	    let op_val='';
	    switch (ans_opt.options) {
			case 'image':
				op_val=<img src={rootDomainUrl+"admin/test_image_files/"+ans_opt.add_on_answer_image} alt="" width="150" height="150"/>
			break;
			case 'audio':
				op_val=<audio controls controlsList="nodownload">
				<source src={rootDomainUrl+"admin/test_audio_files/"+ans_opt.add_on_answer_audio} type="audio/mpeg" />
				</audio>
			break;
			case 'video':
				op_val=this.video_frame(ans_opt.add_on_answer_video, '');
			break;
			default:
				op_val=<div dangerouslySetInnerHTML={{ __html:ans_opt.options}}></div>
			break;
		}
    	return op_val;
	}

	submitbuttons(){
		return <div id="InActive" className="button">
		<input value="Submit" className="button_org_inactive" type="button" onClick={(e)=>this.submittest()}/>
		</div>
	}

	getquestion(quest_det,ans_opt,i){
	    let qty_val=[];
	    let question_type = quest_det.question_type;
    	let rs_img = (ans_opt.score>0) ? process.env.PUBLIC_URL +'/images/tick.gif' : process.env.PUBLIC_URL +'/images/crossmark.gif';
    	switch (question_type) {
			case 1:
				qty_val=<li key={`list_${i}`} className="qleft">
				<span className="flefts"><img src={rs_img} alt="" border="0" /></span>
				<span className="flefts"><input type='radio' defaultChecked={$.inArray(ans_opt.mcq_answer_id_pk, quest_det.answered)>=0} name={quest_det.question_id} onClick={(e)=>handleRadio(e)} value={ans_opt.mcq_answer_id_pk} disabled /></span>
				<span className="fleft">{this.getoptions(ans_opt)}</span>
				</li>
			break;
			case 2:
				qty_val=<li key={`list_${i}`} className="qleft"><span className="fleft">{i}. </span>
				<span className="fleft">{this.getoptions(ans_opt)}</span>
				</li>;
			break;
			case 3:
				qty_val=<li key={`list_${i}`} className="qleft">
				<span className="flefts"><img src={rs_img} alt="" border="0" /></span>
				<span className="flefts"><input defaultChecked={$.inArray(ans_opt.mcq_answer_id_pk, quest_det.answered)>=0} type='checkbox' name={quest_det.question_id} onClick={(e)=>handleCheckbox(e)} value={ans_opt.mcq_answer_id_pk} disabled/ ></span>
				<span className="fleft">{this.getoptions(ans_opt)}</span>
				</li>;
			break;
			case 4:
				qty_val=<li key={`list_${i}`} className="qleft testopt">
				<span className="sfleft">{this.getoptions(ans_opt)}</span>
				</li>;
			break;
			case 5:
				qty_val=<li key={`list_${i}`} className="qleft">
				<span className="flefts"><img src={rs_img} alt="" border="0" /></span>
				<span className="flefts"><input defaultChecked={$.inArray(ans_opt.mcq_answer_id_pk, quest_det.answered)>=0} type='radio' name={quest_det.question_id} onClick={(e)=>handleRadio(e)} value={ans_opt.mcq_answer_id_pk} disabled /></span>
				<span className="fleft">{this.getoptions(ans_opt)}</span>
				</li>;
			break;
			default:
				qty_val='';
			break;
    	}
    	return qty_val;
  	}

  	matchfillfun(mk){
    	let sdf= <li className="qleft">
		<p>Match Set A with correct item in Set B<br />Key in the corresponding no. (1,2,3...) in the box provided</p>
      	<div className="tab-match-container">
			<table className="tbl-match">
				<thead>
					<tr className="tbl-match-head">
	                	<td><b>SET A</b></td>
	                	<td><b>Correct match from Set B</b></td>
						<td><b>SET B</b></td>
	              	</tr>
				</thead>
				<tbody>
					{mk.mcq_match_filling.map((mc,r)=>{
	                return <tr key={`matches_tr_${r}`} className="tbl-match-body">
	                  	<td>
							<div className="statement">
							{mc.match_ques_type==1 && <center>{mc.match_ques_src}</center>}
							{mc.match_ques_type==2 && <center><img src={rootDomainUrl+'/admin/test_image_files/'+mc.match_ques_src} alt="" width="200" height="200" /></center>}
							{mc.match_ques_type==3 && <audio controls controlsList="nodownload">
							<source src={rootDomainUrl+"admin/test_audio_files/"+mc.match_ques_src} type="audio/mpeg" />
							</audio>
							}
							{mc.match_ques_type==4 && this.video_frame(mc.match_ques_src, '') }
							</div>
	                  	</td>
						<td>
							<input type="text" name={mk.question_id} className="txtbox matchtxt" style={{width: "40px"}} title="Enter one digit numeric input" onBlur={(e)=>handleSequence(e)} defaultValue={mk.answered[r]} readonly />
							<img src={(mc.match_correct_ans_order==mk.answered[r]) ? process.env.PUBLIC_URL +'/images/tick.gif' : process.env.PUBLIC_URL +'/images/crossmark.gif'} alt="" border="0" />
						</td>
						<td>
							<div>
								<span style={{float: "left"}}>{r+1}. </span>
			                    <div className="statement">
			                    {mc.match_ans_type==1 && <center>{mc.match_ans_src}</center>}
			                    {mc.match_ans_type==2 && <center><img src={rootDomainUrl+'/admin/test_image_files/'+mc.match_ans_src} alt="" width="200" height="200" /></center>}
			                    {mc.match_ans_type==3 && <audio controls controlsList="nodownload"><source src={rootDomainUrl+"admin/test_audio_files/"+mc.match_ans_src} type="audio/mpeg" /></audio>
			                    }
			                    {mc.match_ans_type==4 && this.video_frame(mc.match_ans_src, '') }
			                    </div>
							</div>
	                  	</td>
	                </tr>
	            })}
	            </tbody>
          	</table>
        </div>
  		</li>;
    	return sdf;
  	}

	video_frame(video_files, text) {

		const { data } = this.props;
		let trackData={

			compseq_id: data.compseq_id,
			lroom_id: data.learning_room_id,
			divider_id: data.divider_id,
			learner_id: data.learner_id,        
			dlr_id: data.dlr_id,
			compo_type:data.compo_type,
			video_id:data.id
		};

		let playlist={
			share:false,
			ratio: 9/16,
			clip:{
			sources: [
					{
					
						type: "video/mp4",
						src: rootDomainUrl+'admin/test_video_files/'+video_files
					}
				]
			}
		};

    	return <Flowplayer key={Date.now()} playlist={playlist} trackData={trackData} />;
	}

	openendquestions(mk){
    	let disp = <li>
			<div className="statement">
				<div className="bluetxt">Your Answer:</div>
				<span className="textbox_align">{mk.answered}</span>
			</div>
		</li>;
    	return disp;
  	}

	render() {
		let data = this.state.testcont, testquestions = this.state.testquestions, seq_op = [];
		let quscomd = this.state.quscomd;
		let optionText = [];
		return (
  		<div className="main-inner">
    		<div className="border-box">
			<div className={data.base_line?"title-box":"title-box tit-new"}>
        			<div title="Videocomponents" className="ts_active_button"></div>
            		<h6>{data.mcq_name?data.mcq_name:''}</h6>
                	<span>{data.base_line?data.base_line:''}</span>
              	</div>
    			<section className="scrol" id="smana-scroll-inner">
        			<section className="viewport">
        				<section className="overview">
          				<div className="inner-content">

          					{ this.state.flowresult && <div className="test-result">
				                <div className="success-msg">Successfully completed the Session.</div>
				                { data.is_betcomponent>0 &&
				                    <div className="test_result">
				                        <table className="bet_table">
				                            <tbody>
				                                <tr className="challenge">
				                                    <td> Your Challenge was to score <span className="set_challenge">{this.state.actualToScore}</span></td>
				                                </tr>
				                                <tr className="challenge_score">
				                                    <td>Your Performance Score is <span className="lrpercentage">{this.state.percentage}%</span> in the Challenge</td>
				                                </tr>

				                                { this.state.betStatus === "lost" && <tr className="challenge_money">
				                                  <td>You have Lost <span className="lost">{this.state.losingAmount}</span> Points in the Challenge</td>
				                                </tr> }

				                                { this.state.betStatus === "won" && <tr className="challenge_money">
				                                  <td>You have Won <span className="won">{this.state.winningAmount}</span> Points in the Challenge</td>
				                                </tr> }

				                                <tr className="challenge_status">
				                                  <td>You have got <span className="perfamnt">{this.state.performanceAmount}</span> Points for your Performance</td>
				                                </tr>
				                            </tbody>
				                        </table>
				                    </div>
				                }

				                <div className="lr-yellow-box"> You have scored <span> {data.actual_score+'/'+data.out_of_score}</span>, YTA<sup>*</sup>.&nbsp;&nbsp;
				                  <a href="javascript:void(0)" className="orange" onClick={()=>this.continueToComplete()} >Click here</a> to view correct answers.
				                </div>

				                { data.show_yta=='1' && <div className="grey-lite">
				                  <span className="bluetxt"><sup>*</sup>Few open ended questions and Audio Answers are yet to be assessed. The final score might change once your observer(s)/ecoach completes their assessment</span>
				                </div> }
									
				                { data.score_comment!=undefined && data.is_performance=='1' && <div className="testperformance">{data.score_comment}</div> }

				                <div className="button">
				                  <input type="submit" value="Continue" title="Continue" className="button_org" onClick={()=>this.backToComponentList()}/>
				                </div>
			            	</div> }

			            	{ !this.state.flowresult &&  <div className="test-result">
								<div className="testscoretop">
									{data.actual_score!=undefined && data.out_of_score!=undefined &&
									<span className="test-score">
										Score: 
										<strong>{data.score_percentage}% ({data.actual_score+'/'+data.out_of_score})
											{data.show_yta=='1' && <span>, </span> }
											{data.show_yta=='1' && <span className="greentxt"> <strong>YTA<sup>*</sup></strong></span> }
										</strong>
									</span>
									}
									{data.show_yta=='1' && <div className="grey-lite">
	            					<span className="greentxt" ><sup>*</sup>Few Open ended questions and Audio answer questions are yet to be assessed. The final score might change once your observer(s)/ecoach completes their assessment</span>
	            					</div>}
								</div>

								{this.state.chart_graph}

								{data.min_taken!=undefined && <div className="testtimeresult">
									<div>Time taken: { data.hrs_taken>0 && data.hrs_taken+'hrs : ' } {data.min_taken} min : {data.sec_taken} sec</div>
									</div>
								}

                  				{ this.state.testquestions.map((mk,index)=>{
                    				return <div key={`a${index}`} className="lr-gray-box test">
	                      		<div className="graybox_border">
									<div className="margbtm para">
										<span className="blwetxt bluetxt" style={{float: "left"}}>Q{index+1}.</span>
			                            <span className="quetn" dangerouslySetInnerHTML={{ __html:mk.mcq_question_name}} />
			                            { mk.question_images.map((val,index)=>{
			                            	if(val!='' && val!=undefined){
			                            		return <div key={`imageq${index}`} className="qleft"><img key={`img_${index}`} src={rootDomainUrl+"admin/test_image_files/"+val} alt="" width={mk.img_width} height={mk.img_height}/></div>
			                            	}
			                            })}
			                            {mk.question_audio.map((aval,aindex)=>{
			                              	if(aval!='' && aval!=undefined){
			                                	return <div key={`auq${aindex}`} className="qleft"><audio key={`audio_${aindex}`} controls controlsList="nodownload"><source src={rootDomainUrl+"admin/test_audio_files/"+aval} type="audio/mpeg" /></audio></div>
			                              	}
			                            })}

			                            {mk.question_video.map((vval,vindex)=>{
			                              	if(vval!='' && vval!=undefined){
			                                	return this.video_frame(vval, '');
			                              	}
			                            })}

			                            <div className="test-ques">
			                              	<div className="ans-select">
			                                <ul key={`aopt${index}`}>

			                                	{(mk.question_type==2) && <li>Your Answer - <span>{mk.answered} <img src={(mk.is_correct_ans>0) ? process.env.PUBLIC_URL +'/images/tick.gif' : process.env.PUBLIC_URL +'/images/crossmark.gif'} /></span></li>}
			                                 	{(mk.question_type==2) && <li>Correct Answer - <span>{mk.correct_answer}</span></li>}

			                                  	{mk.question_type==4 && <span className=""><b>Your options are: </b></span> }
			                                  	{mk.question_option_answers.map((qas,i)=>{
													if (mk.question_type==4) {
														optionText.push(qas.options);
													}
													return this.getquestion(mk,qas,i+1);
			                                 	})}

			                                  	{(mk.question_type==6) && this.openendquestions(mk)}
			                                  	{(mk.question_type==7) && this.matchfillfun(mk)}
			                                </ul>
											{ mk.question_type==8 && <div className="audiorecord">
											<audio key={`raudio_${index}`} controls controlsList="nodownload"><source src={domainUrl +"upload/recorded-voice"+mk.answered} type="audio/mpeg" /></audio>
											</div> }

			                                { mk.question_type==4 && <span className="integratestsmalltxt">
		                                	Your Answer : {mk.answered} <img src={(mk.score>0) ? process.env.PUBLIC_URL +'/images/tick.gif' : process.env.PUBLIC_URL +'/images/crossmark.gif'} alt="" border="0" /><br /> Correct Answer : {mk.correct_answer}
		                                  	</span>
			                                }
		                              		</div>
		                              		<div className="dottedline"></div>
		                              		<div className="dottedline">
			                              		<span className="bluetxt score">
												Your Score - <span className="greentxt"><strong>{ (mk.is_YTA>0 && mk.score<1) ? <span className="greentxt">YTA<sup>*</sup></span> : mk.score}</strong>
												{mk.is_hint_viewed>0 && <strong>(You have viewed hint for this question)</strong> } </span>
												</span>
											</div>
		                            	</div>
		                            	{ mk.is_answer_explained=='1' &&
			                            	<div className="ans-explanation">
												<h3>Answer Explanation</h3>

					                            {quscomd[mk.question_id].videoexpfile!='' && this.video_frame(quscomd[mk.question_id].videoexpfile, '') }

												{quscomd[mk.question_id].audiofile!='' &&
												<audio key='comd' controls controlsList="nodownload"><source src={rootDomainUrl+"admin/test_audio_files/"+quscomd[mk.question_id].audiofile} type="audio/mpeg" /></audio>
		                                        }

												{quscomd[mk.question_id].imagefile!='' &&  <div className="ans-exp-img">
												<img src={rootDomainUrl+"/admin/test_image_files/"+quscomd[mk.question_id].imagefile} />
		                                        </div>
		                                        }
	                                        	{quscomd[mk.question_id].answer_comment!='' && <p dangerouslySetInnerHTML={{ __html:quscomd[mk.question_id].answer_comment}} /> }
											</div>
										}
									</div>
	                      			</div>
	                    		</div>
                				}) }

								{ data.score_comment!=undefined && <span className="testperformance">{data.score_comment}</span>}

								<div className="button">
				                  <input type="submit" value="Continue" title="Continue" className="button_org" onClick={()=>this.backToComponentList()}/>
				                </div>
							</div>
							}

                  		</div>
            		</section>
				</section>
			</section>
			</div>
		</div>
  	);
	}
}



// WEBPACK FOOTER //
// ./src/lr_dlr_components/Ctestresults.js